import AuthLogin from "../views/AuthLogin.vue"
import AuthNewPassword from "../views/AuthNewPassword.vue"
import AuthResetPassword from "../views/AuthResetPassword.vue"
import AuthAccount from "../views/AuthAccount.vue"
import AuthUpdatePassword from "../views/AuthUpdatePassword.vue"

export default [
	{
		path: "/:tenantId/account/detail/:section?",
		component: AuthAccount,
		meta: { featureId: "auth" },
		name: "AuthAccount",
		props: true
	},
	{
		path: "/:tenantId/account/update-password",
		component: AuthUpdatePassword,
		meta: { featureId: "auth" },
		name: "AuthUpdatePassword",
		props: true
	},
	{
		name: "login",
		path: "/:tenantId/login",
		component: AuthLogin,
		meta: { featureId: "auth" },
		props: true
	},
	{
		name: "login",
		path: "/:tenantId/",
		redirect: "/:tenantId/login",
		props: true
	},
	{
		name: "new-password",
		path: "/:tenantId/new-password",
		component: AuthNewPassword,
		meta: { featureId: "auth" },
		props: true
	},
	{
		name: "forgotten-password",
		path: "/:tenantId/forgotten-password",
		component: AuthNewPassword,
		meta: { featureId: "auth" },
		props: true
	},
	{
		name: "reset-password",
		path: "/:tenantId/reset-password",
		component: AuthResetPassword,
		meta: { featureId: "auth" },
		props: true
	}
]
